export let HeadingStructureFailedReason = /*#__PURE__*/function (HeadingStructureFailedReason) {
  HeadingStructureFailedReason["NoMainHeading"] = "NoMainHeading";
  HeadingStructureFailedReason["MultipleMainHeadings"] = "MultipleMainHeadings";
  HeadingStructureFailedReason["HeadingDefinition"] = "HeadingDefinition";
  return HeadingStructureFailedReason;
}({});

// Simplified event system types

// Simplified handlers interface
//# sourceMappingURL=index.js.map